import React from 'react';
import { Link } from 'react-router-dom';
import './HamburgerMenu.css'; // Import the CSS for styling

const MobileMenu = ({ isOpen, onClose, currentLang, onLanguageChange, translations }) => {
  // Use passed translations or fallback to defaults if not provided (though they should be)
  const nav = translations?.nav || {
    about: "About",
    features: "Features",
    testimonials: "Vision",
    faq: "FAQ",
    download: "Download",
    kvkk: "KVKK",
    terms: "Terms of Use"
  };

  return (
    <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
      <div className="mobile-menu-content">
        <button className="close-button" onClick={onClose}>×</button>
        <nav className="mobile-nav">
          <a href="#about" onClick={onClose}>{nav.about}</a>
          <a href="#features" onClick={onClose}>{nav.features}</a>
          <a href="#testimonials" onClick={onClose}>{nav.testimonials}</a>
          <a href="#faq" onClick={onClose}>{nav.faq}</a>
          <Link to="/kvkk" onClick={onClose}>{nav.kvkk}</Link>
          <Link to="/terms" onClick={onClose}>{nav.terms}</Link>
          
          <div className="mobile-lang-container">
            <select 
              className="mobile-lang-select"
              value={currentLang}
              onChange={onLanguageChange}
            >
              <option value="tr">🇹🇷 Turkish</option>
              <option value="en">🇬🇧 English</option>
            </select>
          </div>
          
          <button className="mobile-cta">{nav.download}</button>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;